import React from 'react';

/**
 * Hamburger menu button component
 */
export const HamburgerButton = ({ isOpen, onClick }) => {
  return (
    <button
      className={`hamburger-btn ${isOpen ? 'active' : ''}`}
      onClick={onClick}
    >
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
      <span className="hamburger-line"></span>
    </button>
  );
};
